import { jsx as e } from "react/jsx-runtime";
const i = ({ ...l }) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-hidden": "true",
    ...l,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.477 6.538a.75.75 0 0 1 1.046-1.076l6 5.984a.75.75 0 0 1 .015 1.061l-6 6.016a.75.75 0 1 1-1.076-1.046l5.477-5.478-5.462-5.461Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  i as IconChevronRight
};
